import React from "react";

const InquirySection = ({ openModal }) => {
  return (
    <section className="wpo-contact-pg-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col col-lg-10 offset-lg-1">
            <div className="wpo-contact-form-area">
              <form className="form-center">
                <div className="content-width">
                  <h2>Have Any Question?</h2>
                  <p>
                    If you are looking to book an event, please click on the
                    inquiry button and fill in your Event details and receive
                    the ballroom recommendation Email.
                  </p>
                  <a className="theme-btn" href="#" onClick={openModal}>
                    Inquiry
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InquirySection;
